<script>
export default {
    name: 'LayoutDefault',
};
</script>

<script setup>
import { storeToRefs } from 'pinia';
import AllowCookieBanner from '@/components/allow-cookie-banner.vue';
import TheLoader from '@/components/the-loader.vue';
import AppHeader from '@/components/app/header/index.vue';
import AppSidebar from '@/components/app/sidebar/index.vue';
import { useAppSidebarStore } from '@/store/pinia/app/sidebar.js';

const sidebarStore = useAppSidebarStore();
const { collapsed } = storeToRefs(sidebarStore);
</script>

<template>
    <div class="flex flex-1 justify-center bg-linear-to-br from-secondary-950 from-35% to-primary-700">
        <the-loader />
        <app-sidebar />
        <main class="flex w-0 flex-1 flex-col overflow-hidden">
            <app-header />
            <div
                class="relative flex-1 overflow-auto bg-gray-100 shadow-sm focus:outline-hidden @3xl/app:rounded-tl-xl"
                data-test="content"
            >
                <slot />
            </div>
            <allow-cookie-banner
                class="ml-0"
                :class="collapsed ? 'md:ml-20' : 'md:ml-64'"
            />
        </main>
    </div>
</template>
